<template>
  <div class="overlay-container">
    <div class="background fullscreen" v-show="fullscreen && padded" @click="$emit('close')" />
    <v-container fluid class="overlay py-0" :class="{ fullscreen, padded, dark }">
      <v-row :class="{ 'sticky': fullscreen }" class="overlay-heading" v-if="heading || allowClose">
        <v-col cols="10" v-if="heading">{{ heading }}</v-col>
        <v-spacer v-if="!heading && allowClose" />
        <v-col @click="$emit('close')" v-if="allowClose" class="text-right" >
          <i class="fa fa-times-circle close-pane" aria-hidden="true" />
        </v-col>
      </v-row>
      <v-row class="overlay-content">
        <v-col class="fill-height" :class="{ 'pa-0': !padded && !fullscreen }">
          <v-container class="overlay-content" ref="content">
            <slot />
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Overlay',
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    allowClose: {
      type: Boolean,
      default: true
    },
    padded: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
// Including #app to fix a CSS load order bug
#app {
  .overlay-container {
    .overlay {
      background-color: #FFFFFF;
      z-index: 5;
      max-width: 100%;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
      border: none;

      &.dark {
        background-color: var(--v-primary-base)
      }

      &-heading {
        color: #FFFFFF;
        background-color: var(--v-primary-base);

        &.sticky {
          position: sticky;
          top: 0;
          z-index: 2;
        }
      }

      &-content {
        padding: 0px 0px;
        position: relative;
        height: 100%;
        transition: all 0.3s;
      }
    }

    .close-pane {
      cursor: pointer;
    }

    .fullscreen {
      position: absolute;
      top: 0;
      left: 0;
      overflow-y: auto;
      border: none;
      width: 100%;
      height: 100%;
      max-width: none;

      &.background {
        background-color: rgba(0, 0, 0, 0.8);
        cursor: pointer;
        z-index: 4;
        animation-duration: 0.3s;
      }

      &.overlay {
        z-index: 5;
        margin-bottom: 8px;
        background-color: white;
        margin-bottom: 0;
        box-shadow: none;

        &.padded {
          top: 50px;
          left: 75px;
          width: calc(100% - 150px);
          height: calc(100% - 100px);
        }
      }

      .overlay-content {
        background-color: white;
        height: calc(100% - 48px)
      }

      .close-pane {
        transform: scale(2.0);
      }
    }

    @media only screen and (min-width: 960px) {
      .overlay {
        margin-bottom: 8px;

        &:not(.fullscreen) {
          max-width: 30vw;
        }
      }
    }
  }
}
</style>
